import { Box, Grid } from '@mui/material';
import { 
	BooleanInput, 
	Create, 
	DateInput, 
	NumberInput, 
	SimpleForm, 
	TextInput 
} from 'react-admin';

const DatingEventCreate = () => (
	<Create resource="dating-events">
		<SimpleForm>
			<Grid spacing={2} container>
				<Grid item sm={6}>
					<TextInput source="title" fullWidth label="כותרת עברית" dir="rtl" />
				</Grid>
				<Grid item sm={6}>
					<TextInput source="title_english" fullWidth label="כותרת אנגלית" dir="ltr" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={12}>
					<TextInput source="description.he" fullWidth label="תיאור" multiline dir="rtl" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<TextInput 
						source="time" 
						fullWidth 
						label="תאריך ושעה" 
						type="datetime-local"
						helperText="בחר תאריך ושעה"
					/>
				</Grid>
				<Grid item sm={6}>
					<TextInput source="address" fullWidth label="כתובת" dir="rtl" />
				</Grid>

				<Grid item sm={6}>
					<TextInput source="duration" fullWidth label="זמן משך (דקות)" dir="rtl" />
				</Grid>

				
				<Box width="100%" />
				<Grid item sm={6}>
					<NumberInput source="limitInvatations" fullWidth label="מספר הזמנות מקסימלי" />
				</Grid>
				<Grid item sm={6}>
					<BooleanInput source="isActive" fullWidth label="פעיל" defaultChecked={true} />
				</Grid>
			</Grid>
		</SimpleForm>
	</Create>
);

export default DatingEventCreate;
